document.addEventListener("DOMContentLoaded", function () {
    // console.log(document.title);

    const serializeObject = (form) => {
        const formData = new FormData(form);

        const pairs = {};
        for (const [name, value] of formData) {
            pairs[name] = value;
        }

        return pairs;
    }

    const sendRequest = (el, form) => {
        let send = true;

        const alert = el.querySelector('.adam__alert.alert--error');
        alert.classList.add('alert--hidden');

        const req = serializeObject(form);

        const formData = new FormData(form);
        formData.forEach((value, key) => {
            if (key.endsWith('[]')) {
                if (!Array.isArray(req[key])) {
                    req[key] = [];
                }

                if (!req[key].includes(value)) {
                    req[key].push(value);
                }
            }
        });

        const privacyError = el.querySelector('.adam__form__privacy .adam__hint');
        if (!req.hasOwnProperty('privacy') && !!privacyError) {
            privacyError.classList.remove('hint--hidden');
            send = false;
        }

        if (send) {
            fetch('/' + form.dataset.locale + '/api/forms/' + form.dataset.form, {
                method: 'POST',
                body: JSON.stringify(req),
                credentials: 'same-origin',
                headers: { 'content-type': 'application/json' }
            })
            .then((response) => response.json())
            .then((data) => {
                if (!data.result) {
                    if (data.code !== 418) {
                        alert.classList.remove('alert--hidden');
                    }
                    return;
                }

                // Data handling
                if ((data.type == 'resource' || data.type == 'brochure') && req.email) {
                    document.cookie = `resource_email=${req.email}; path=/; max-age=${60 * 60 * 24 * 14};`;
                }

                let formType = jQuery(form).attr('data-form-type');
                let formTypeParameter = jQuery(form).attr('data-form-type-parameter');

                // Form reset
                form.reset();
                if (el.closest('.adam__modal')) {
                    el.closest('.adam__modal').classList.remove('modal--open');
                }

                // Response modal
                const modal = el.querySelector('.adam__modal').cloneNode(true);
                modal.classList.add('modal--open');

                modal.removeAttribute('id');
                const content = modal.querySelector('.adam__modal__content');

                if (data.hasOwnProperty('demioUrl')) {
                    content.innerHTML = content.innerHTML.replace('{{', `<a target="_blank" href="${data.demioUrl}">`).replace('}}', '</a>');

                }

                if (typeof formType != 'undefined' && typeof content != 'undefined' && formType) {
                    content.classList.add('form-type-' + formType);
                }

                if (typeof formTypeParameter != 'undefined' && typeof content != 'undefined' && formTypeParameter) {
                    content.classList.add('form-type-parameter-' + formTypeParameter);
                }

                modal.querySelector('.adam__modal__close').addEventListener('click', () => {
                    modal.remove();
                    document.body.classList.remove('adam__modal__show');
                });
                document.body.appendChild(modal);

                if ((data.type == 'resource' || data.type == 'brochure')) {
                    window.dataLayer.push({'event': 'download_file', 'file': document.title});
                } else {
                    window.dataLayer.push({'event': 'invio_form'});
                }

                if (data.type == 'restrictedContent') {
                    jQuery('.restricted-content').removeClass('restricted-content').addClass('restricted-content-unlocked');
                    document.cookie = `restriction_email=${req.email}; path=/; max-age=${60 * 60 * 24};`;
                    jQuery(form).remove();
                }
                
            });
        }
    };

    // Events
    const elements = document.querySelectorAll('.adam__form');
    elements.forEach($el => {
        const $form = $el.querySelector('.adam__form__content');
        $form.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();
            sendRequest($el, $form);
        });

        const $sector = $form.querySelector('.adam__input.input--sector');
        if ($sector) {
            const $industry = $form.querySelector('.adam__input.input--industry');
            $sector.querySelector('select').addEventListener('change', function () {
                let html = '', industries = [], value = this.value;
                if (value !== '') {
                    industries = JSON.parse($sector.querySelector(`select option[value="${value}"]`).getAttribute('data-industries'));
                    industries.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1).forEach(industry => {
                        html += `<option value="${industry.id}">${industry.name}</option>`;
                    });
                }
                $industry.querySelector('select').innerHTML = html;
                $industry.style.display = industries.length < 2 ? "none" : "block";
            });
        }
    });
});